import { createRef, Component } from 'react';
import propTypes from 'prop-types';
import { initTooltipsWithOffset } from '../../../common/tooltip-popup/tooltip-with-offset.js';
import { createWEEEPricesTooltip } from '../../../common/products-list/weee-prices.js';

export class WeeePrices extends Component {
  constructor(props) {
    super(props);
    this.ref = createRef();
  }

  componentDidMount() {
    this.updateTooltip();
  }

  componentDidUpdate() {
    this.updateTooltip();
  }

  updateTooltip() {
    const { prices } = this.props;
    const { current } = this.ref;

    if (!current) {
      return;
    }

    const priceComponent = createWEEEPricesTooltip(prices);

    initTooltipsWithOffset(priceComponent);
    current.innerHTML = '';
    current.appendChild(priceComponent);
  }

  render() {
    const { prices } = this.props;

    return prices && (<div className=".js-weee-prices-placeholder" ref={this.ref} />);
  }
}

WeeePrices.propTypes = {
  prices: propTypes.shape({
    weeePriceLabel: propTypes.string,
    weeePriceLabelMulti: propTypes.string,
    weeeLamp: propTypes.string,
    weeePackage: propTypes.string,
    weeePro: propTypes.string
  })
};

WeeePrices.defaultProps = {
  prices: null
};
